import { API_URL } from '../../environment';
import { ducksActionCreator } from '../ducksHelpers';

export const blockedSlotSettings = {
  stateName: 'blockedSlot',
  dataType: 'object',
  actions: {
    fetch: 'ducks/schedule/FETCH_BLOCKED_SLOT',
    create: 'ducks/schedule/CREATE_BLOCKED_SLOT',
    update: 'ducks/schedule/UPDATE_BLOCKED_SLOT',
    delete: 'ducks/schedule/DELETE_BLOCKED_SLOT',
  },
};

// With a counsellorId (admin schedule) requests go through the admin API;
// otherwise the practitioner manages their own blocked slots.
const baseUrl = counsellorId =>
  counsellorId
    ? `${API_URL}/admin/blocked_slots`
    : `${API_URL}/practice/blocked_slots`;

const counsellorQuery = counsellorId =>
  counsellorId ? `?counsellor=${counsellorId}` : '';

export function fetchBlockedSlot(
  id,
  callback = () => {},
  errorCallback = () => {},
  counsellorId = null,
) {
  return ducksActionCreator(
    blockedSlotSettings.actions.fetch,
    'get',
    `${baseUrl(counsellorId)}/${id}${counsellorQuery(counsellorId)}`,
    {},
    true,
    callback,
    errorCallback,
  );
}

export function createBlockedSlot(
  values,
  callback = () => {},
  errorCallback = () => {},
  counsellorId = null,
) {
  return ducksActionCreator(
    blockedSlotSettings.actions.create,
    'post',
    `${baseUrl(counsellorId)}${counsellorQuery(counsellorId)}`,
    { ...values },
    true,
    callback,
    errorCallback,
  );
}

export function updateBlockedSlot(
  id,
  values,
  callback = () => {},
  errorCallback = () => {},
  counsellorId = null,
) {
  return ducksActionCreator(
    blockedSlotSettings.actions.update,
    'put',
    `${baseUrl(counsellorId)}/${id}${counsellorQuery(counsellorId)}`,
    { ...values },
    true,
    callback,
    errorCallback,
  );
}

export function deleteBlockedSlot(
  id,
  callback = () => {},
  errorCallback = () => {},
  counsellorId = null,
) {
  return ducksActionCreator(
    blockedSlotSettings.actions.update,
    'delete',
    `${baseUrl(counsellorId)}/${id}${counsellorQuery(counsellorId)}`,
    {},
    true,
    callback,
    errorCallback,
  );
}
